import { render, staticRenderFns } from "./suggestedpeople.vue?vue&type=template&id=ed49051c&scoped=true"
import script from "./suggestedpeople.vue?vue&type=script&lang=js"
export * from "./suggestedpeople.vue?vue&type=script&lang=js"
import style0 from "./suggestedpeople.vue?vue&type=style&index=0&id=ed49051c&prod&scoped=true&lang=css"
import style1 from "./suggestedpeople.vue?vue&type=style&index=1&id=ed49051c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed49051c",
  null
  
)

export default component.exports